import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  modal_message:null,
  open_modal:false,

 
};

const Success_Modal_Slice = createSlice({
  name: "Confirm_Modal",
  initialState,
  reducers: {
     open_success_modal(state,action){
         state.open_modal = true;
         state.modal_message = action.payload
     },
     close_success_modal(state,action){
        state.open_modal = false;
        state.modal_message = ""
     },
  

  },
});

export const {
    open_success_modal,
    close_success_modal,
} = Success_Modal_Slice.actions

export default Success_Modal_Slice.reducer;